import React, { useContext, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/system";
import cx from "classnames";

import { LogoTypeContext } from "../../containers/FormLayout/LogoTypeProvider";
import { isOtpVerified } from "../../store/selectors/otp";
import routes from "../../routes";

import { LOGO_ELITE, LOGO_ELITE_ISLAMIC, LOGO_ISLAMIC, LOGO_STANDART } from "./constants";

import { ReactComponent as EliteIslamicLogo } from "../../assets/images/logo-elite-islamic.svg";
import { ReactComponent as StandartLogo } from "../../assets/images/logo-standart.svg";
import { ReactComponent as EliteLogo } from "../../assets/images/logo-elite.svg";
import { ReactComponent as IslamicLogo } from "../../assets/images/logo-islamic_new.svg";

import { HeaderButtonGroup } from "../HeaderButtonGroup";
import { StyledHeader, StyledHeaderButton } from "./styled";
import { LayoutContext } from "../../containers/FormLayout/LayoutProvider";
import SaveAndClose from "../SaveAndClose";
import { getAccountType, getIsIslamicBanking } from "../../store/selectors/appConfig";
import { useTrackingHistory } from "../../utils/useTrackingHistory";
import { accountNames } from "../../constants";
import HeaderProgressBar from "../ProgressBar/ProgressBarContainer";
import { checkLoginStatus } from "../../store/selectors/loginSelector";

const HeaderComponent = ({ className, isOtpVerified, isAgent }) => {
  const { pathname } = useLocation();
  const queryParams = useLocation().search;
  const isIslamic = useSelector(getIsIslamicBanking);
  const accountType = useSelector(getAccountType);
  const pushHistory = useTrackingHistory();
  const isDesktop = useMediaQuery("(min-width: 769px)") || window.innerWidth > 769;
  const logoType = useContext(LogoTypeContext);
  const [, , , showSaveNClose = false, showResumeBtn = false] = useContext(LayoutContext);

  //ro-assist-brd3-16

  const { isFromInvitationLink } = useSelector(state => state.applicantInfo);
  const [isElite, setIsElite] = useState(false);

  const logoClassName = cx("logo");

  const handleRedirection = (path, replaceHistory = false) => {
    pushHistory(path, replaceHistory);
  };

  useEffect(() => {
    setIsElite(accountType === accountNames.elite);
  }, [accountType]);

  return (
    // <>
    <StyledHeader logoType={logoType} isIslamic={isIslamic} isElite={isElite}>
      <Link
        to={routes.quickapplyLanding + queryParams}
        className={isOtpVerified || isFromInvitationLink || isAgent ? "disabled" : ""}
      >
        {(() => {
          switch (logoType) {
            case LOGO_ELITE_ISLAMIC:
              return <EliteIslamicLogo className={logoClassName} />;
            case LOGO_ELITE:
              return <EliteLogo className={logoClassName} />;
            case LOGO_ISLAMIC:
              return <IslamicLogo className={logoClassName} />;
            case LOGO_STANDART:
            default:
              return <StandartLogo className={logoClassName} />;
          }
        })()}
      </Link>
      {isDesktop && <HeaderProgressBar />}
      <div className="headerAction">
        {pathname.includes("application-overview") && (
          <HeaderButtonGroup
            buttonColor="white"
            classes="applicationOverviewTrackNSwitch"
            showSwitchButton={isDesktop}
          />
        )}
        {showSaveNClose && <SaveAndClose extraClasses="saveNCloseHeader" />}
        {showResumeBtn && (
          <StyledHeaderButton onClick={() => handleRedirection(routes.comeBackLogin)}>
            Resume
          </StyledHeaderButton>
        )}
      </div>
    </StyledHeader>
  );
};

const mapStateToProps = state => ({
  isOtpVerified: isOtpVerified(state),
  isAgent: checkLoginStatus(state)
});

export const Header = connect(mapStateToProps)(HeaderComponent);
